import { Http } from '@mygpt/app/http';

export interface RobotListParams {
  page: number;
  size: number;
}

// 定义请求体的接口
export interface CreateBotRequestBody {
  name: string;
  discrible: string;
  subject_name: string | null;
  prompt: string;
  url: string | null;
  dataset_ids: string[] | null;
  init_default_datasets: boolean;
  ai_type: string;
  ai_model: string;
  robot_type: string;
  agent_function_call_ids: string[];
  // 资产范围：null/不传表示个人资产，组织ID表示组织资产
  company_id?: string | null;
}

// 定义生成 prompt 请求体的接口
export interface GeneratePromptRequestBody {
  prompt_in: string;
  cur_prompt: string | null;
  stream: boolean;
}

export const createBot = async (requestBody: CreateBotRequestBody) => {
  const { post } = Http.use();
  // 处理 company_id：如果为 null 则不传，如果有值则传入
  const { company_id, ...rest } = requestBody;
  const bodyWithCompanyId = company_id ? { ...rest, company_id } : rest;
  const response = await post('/ais', bodyWithCompanyId);

  if (response.status < 200 || response.status >= 300) {
    throw new Error('请求失败');
  }

  return response.data;
};

export interface GeneratePromptResponse {
  prompt: string;
  change_summary?: string;
}

export const generatePrompt = async (requestBody: GeneratePromptRequestBody): Promise<GeneratePromptResponse> => {
  const { post } = Http.use();
  const response = await post<GeneratePromptResponse>('/v1/ais/gen_prompt', requestBody);

  if (response.status < 200 || response.status >= 300) {
    throw new Error('请求失败');
  }

  return response.data;
};
